import styled from "styled-components"

export const FilterContainer = styled.div`
    background-color: white;
    border-collapse: collapse;
    display: flex;
    padding-top:15px;
    justify-content: space-between;
    align-items: baseline;
    @media screen and (max-width: ${props => props.theme.mobileTableBreakPoint}px) {
        flex-direction: column; 
        align-items: center;
    }
`

export const ViewDiv = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100% - 200px);
    overflow: hidden;
    margin: 0px auto 60px auto;
    @media screen and (max-width: ${props => props.theme.mobileTableBreakPoint}px) {
        margin: 0; 
    }
    @media screen and (min-width: ${props => props.theme.mobileTableBreakPoint}px) {
        width:1035px;
        overflow-x: auto;
    }
    @media screen and (min-width: 1550px) {
        width: auto;
        margin: 0px 250px 60px 250px;
    }
`